import * as React from 'react'
function SvgFlag(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32 6H10c0-1.2-.8-2-2-2s-2 .8-2 2v28c0 1.2.8 2 2 2s2-.8 2-2V24h22a2 2 0 002-2V8a2 2 0 00-2-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgFlag
